import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftOperationsProps } from './props';
import { SarlaftOperations } from '../../../../../../shared/types/modules/sarlaft';
import { ISelect } from '../../../../../../shared/types/shared';
import {
    asyncGetCountries,
    asyncGetForeignCities,
} from '../../../../../../services/location.service';
import { formatParams } from '../../../../../../shared/utils/params';

export const useSarlaftlaftOperations = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftOperationsProps) => {
    const [cities, setCities] = useState<ISelect[]>([]);
    const [countries, setCountries] = useState<ISelect[]>([]);

    const onSubmit = (data: SarlaftOperations) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('typeProduct', data?.typeProduct || '');
        formik?.setFieldValue('numberProduct', data?.numberProduct || '');
        formik?.setFieldValue('entity', data?.entity || '');
        formik?.setFieldValue('amount', data?.amount || '');
        formik?.setFieldValue('foreignCity', data?.foreignCity || '');
        formik?.setFieldValue('country', data?.country || '');
        formik?.setFieldValue('currency', data?.currency || '');
    }, [data]);

    useEffect(() => {
        asyncGetForeignCities().then((cities) =>
            setCities(formatParams(cities))
        );
        asyncGetCountries().then((countries) =>
            setCountries(formatParams(countries))
        );
    }, []);

    return {
        formik,
        cities,
        countries,
    };
};
